// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Invoices from './Invoices';

export default compose(
    connect(
        state => ({
            user: state?.global?.user || [],
        }),
        dispatch => ({}),
    ),
)(Invoices);